/* Imports */
import { defineStore } from 'pinia';
import VueCookies from 'vue-cookies';

/* Helpers */
import { request } from '../helpers/mainHelpers.js';

export const useCustomerGroupsStore = defineStore('customerGroups', {
  state: () => ({
    customerGroups: 'none',
  }),
  getters: {
    getCustomerGroups: (state) => state.customerGroups,
  },
  actions: {
    async loadCustomerGroups() {
      const customerId = VueCookies.get('GARMIN-SSO-CUST-GUID') || '';
      const cache = customerId ? 'no-store, max-age=0' : '';
      const url = `${window.location.origin}/compare/api/getCustomerGroups`;
      const headers = {
        'Cache-Control': cache || 'public, max-age=3600, s-maxage=3600',
      };

      try {
        const response = await request({
          method: 'POST',
          url,
          headers,
        });
        return response;
      } catch (error) {
        throw new Error('Error calling getCustomerGroups API', error?.message);
      }
    },
    async setCustomerGroups() {
      const customerGroupsCookie = VueCookies.get('GarminBuyCacheKey') ? decodeURIComponent(VueCookies.get('GarminBuyCacheKey')) : null;
      let customerGroups;
      let customerGroupsResponse;
      try {
        customerGroupsResponse = await this.loadCustomerGroups();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error retrieving customer group from server', error?.message);
      } finally {
        if (customerGroupsResponse && customerGroupsResponse.length) {
          customerGroups = customerGroupsResponse;
        } else if (customerGroupsCookie) {
          customerGroups = customerGroupsCookie;
        } else {
          customerGroups = 'none';
        }
      }

      const employeeFlag = customerGroups === 'US';
      window.WCS_ANALYTICS_OVERRIDES = { ...window.WCS_ANALYTICS_OVERRIDES };
      window.WCS_ANALYTICS_OVERRIDES.employeeFlag = employeeFlag ? 'TRUE' : false;

      this.customerGroups = customerGroups;
    },
  },
});

export default useCustomerGroupsStore;
